let url = new Object()
const name = `orders`

const common = `/api/${name}/`
url.common = {
}

const adminUrl = `/api/${name}/admin/`
url.admin = {
  getAll: `${adminUrl}getall`,
  getOne: `${adminUrl}getOne`,
  delete: `${adminUrl}delete`,
  getProceeds: `${adminUrl}getproceeds`,
  getProceedsReport: `${adminUrl}getproceedsreport`,
  getMassage: `${adminUrl}getmassage`,
  getMassageReport: `${adminUrl}getmassagereport`,
  getRating: `${adminUrl}getrating`,
  getRatingReport: `${adminUrl}getratingreport`,
  getKontrollersDistinct: `${adminUrl}getkontrollersdistinct`,
  findKontroller: `${adminUrl}findkontroller`
}

const dealerUrl = `/api/${name}/dealer/`
url.dealer = {
  getAll: `${dealerUrl}getall`,
  getOne: `${dealerUrl}getOne`,
  getProceeds: `${dealerUrl}getproceeds`,
  getProceedsReport: `${dealerUrl}getproceedsreport`,
  getMassage: `${dealerUrl}getmassage`,
  getMassageReport: `${dealerUrl}getmassagereport`
}

export default url
